import { join } from '../../utils/strings';
import {
  navigateToProductListWithClusters,
  navigateToProductListWithClusterAndGenre,
} from '../../utils/navigations';

export const navigateToCluster = ({
  history,
  clusterType,
  onSelectCluster,
  genre,
}) => (clusterName) => {
  const clusters = join({
    part2: clusterName,
    part1: clusterType,
    separator: '|',
  });

  onSelectCluster();
  if (genre) {
    navigateToProductListWithClusterAndGenre({
      history,
      clusters: `${genre} | ${clusters}`,
      genre,
    });
  } else {
    navigateToProductListWithClusters({ history, clusters });
  }
};
